<template>
  <Content />
</template>
<script route="/hr/payment-manage/pay-flow">
  import Content from '@/views/hr/PaymentManage/PayFlow/content.jsx'
  export default {
    components: {
      Content
    }
  }
</script>